type configType = {
  cognito: {
    REGION: string;
    USER_POOL_ID: string;
    APP_CLIENT_ID: string;
    IDENTITY_POOL_ID: string;
    DOMAIN: string;
    SCOPE: string[];
    REDIRECT_SIGN_IN: string;
    REDIRECT_SIGN_OUT: string;
    RESPONSE_TYPE: string;
  };
  storage: {
    BUCKET: string;
  };
  apiGateway: {
    MyVideo: {
      NAME: string;
      REGION: string;
      URL: string;
    };
    Recognition?: {
      NAME: string;
      REGION: string;
      URL: string;
    };
    WebForm?: {
      NAME: string;
      REGION: string;
      URL: string;
    };
    QualityMonitoring?: {
      NAME: string;
      REGION: string;
      URL: string;
    };
  };
  Interactions?: {
    bots: {
      MyRecognition: {
        NAME: string;
        REGION: string;
        ALIAS: string;
      };
    };
  };
};

const dev: configType = {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_UGyz4NuYI",
    APP_CLIENT_ID: "11l06pgko73ttmddn9odg4s8vo",
    IDENTITY_POOL_ID: "eu-west-1:e5297d3e-80db-4656-affb-bdfd940b35dd",
    DOMAIN: "dev-mymercedes.auth.eu-west-1.amazoncognito.com",
    SCOPE: ["openid", "aws.cognito.signin.user.admin"],
    REDIRECT_SIGN_IN: "https://d1sl6p86cydzwb.cloudfront.net/",
    // REDIRECT_SIGN_IN: "http://localhost:3000/",
    REDIRECT_SIGN_OUT: "https://sso-int.mercedes-benz.com/idp/startSLO.ping",
    RESPONSE_TYPE: "code",
  },
  storage: {
    BUCKET: "dev-mymercedes-storage",
  },
  apiGateway: {
    MyVideo: {
      NAME: "MyVideo",
      REGION: "eu-west-1",
      URL: "https://xoornaokg1.execute-api.eu-west-1.amazonaws.com/dev",
    },
    Recognition: {
      NAME: "Recognition",
      REGION: "eu-west-1",
      URL: "https://2v0i4hvuej.execute-api.eu-west-1.amazonaws.com/dev",
    },
    WebForm: {
      NAME: "WebForm",
      REGION: "eu-west-1",
      URL: "https://u3ujc4xiil.execute-api.eu-west-1.amazonaws.com/dev",
    },
    QualityMonitoring: {
      NAME: "QualityMonitoring",
      REGION: "eu-west-1",
      URL: "https://8kdy2fv8dh.execute-api.eu-west-1.amazonaws.com/dev",
    },
  },
  Interactions: {
    bots: {
      MyRecognition: {
        NAME: "dev_MyRecognition",
        REGION: "eu-west-1",
        ALIAS: "$LATEST",
      },
    },
  },
};

const uat: configType = {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_iGNxmVVQO",
    APP_CLIENT_ID: "6al6u8tjmc5jqc6n0ih2db1cg0",
    IDENTITY_POOL_ID: "eu-west-1:da51a586-805b-4cb4-b6d0-81ff691a0938",
    DOMAIN: "uat-mymercedes.auth.eu-west-1.amazoncognito.com",
    SCOPE: ["openid", "aws.cognito.signin.user.admin"],
    REDIRECT_SIGN_IN: "https://d22karmtt3mp7o.cloudfront.net/",
    REDIRECT_SIGN_OUT: "https://sso-int.mercedes-benz.com/idp/startSLO.ping",
    RESPONSE_TYPE: "code",
  },
  storage: {
    BUCKET: "uat-mymercedes-storage",
  },
  apiGateway: {
    MyVideo: {
      NAME: "MyVideo",
      REGION: "eu-west-1",
      URL: "https://qwtn5j7wlc.execute-api.eu-west-1.amazonaws.com/uat",
    },
    Recognition: {
      NAME: "Recognition",
      REGION: "eu-west-1",
      URL: "https://4ki834uocc.execute-api.eu-west-1.amazonaws.com/uat",
    },
    WebForm: {
      NAME: "WebForm",
      REGION: "eu-west-1",
      URL: "https://fx53h7na38.execute-api.eu-west-1.amazonaws.com/uat",
    },
    QualityMonitoring: {
      NAME: "QualityMonitoring",
      REGION: "eu-west-1",
      URL: "https://urz4pnrjb8.execute-api.eu-west-1.amazonaws.com/uat",
    },
  },
  Interactions: {
    bots: {
      MyRecognition: {
        NAME: "uat_MyRecognition",
        REGION: "eu-west-1",
        ALIAS: "$LATEST",
      },
    },
  },
};

const prod: configType = {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_3F2kIwWZr",
    APP_CLIENT_ID: "75u9g41inobvei1engp577pesg",
    IDENTITY_POOL_ID: "eu-west-1:3eccaeab-ccb5-49f8-8996-f03e8fb7e266",
    DOMAIN: "prod-mymercedes.auth.eu-west-1.amazoncognito.com",
    SCOPE: ["openid", "aws.cognito.signin.user.admin"],
    REDIRECT_SIGN_IN: "https://www.changethegameuk.com/",
    REDIRECT_SIGN_OUT: "https://sso.mercedes-benz.com/idp/startSLO.ping",
    RESPONSE_TYPE: "code",
  },
  storage: {
    BUCKET: "prod-mymercedes-storage",
  },
  apiGateway: {
    MyVideo: {
      NAME: "MyVideo",
      REGION: "eu-west-1",
      URL: "https://49h7em16md.execute-api.eu-west-1.amazonaws.com/prod",
    },
    Recognition: {
      NAME: "Recognition",
      REGION: "eu-west-1",
      URL: "https://s7om5woyyc.execute-api.eu-west-1.amazonaws.com/prod",
    },
    WebForm: {
      NAME: "WebForm",
      REGION: "eu-west-1",
      URL: "https://qlf5keqded.execute-api.eu-west-1.amazonaws.com/prod",
    },
    QualityMonitoring: {
      NAME: "QualityMonitoring",
      REGION: "eu-west-1",
      URL: "https://1ego3kmgn3.execute-api.eu-west-1.amazonaws.com/prod",
    },
  },
  Interactions: {
    bots: {
      MyRecognition: {
        NAME: "prod_MyRecognition",
        REGION: "eu-west-1",
        ALIAS: "$LATEST",
      },
    },
  },
};

const stage = process.env.REACT_APP_STAGE;

const config = {
  // Add common config values here
  // Default to dev if not set
  ...(stage === "prod" ? prod : stage === "uat" ? uat : dev),
};

export default config;
